import { useTranslation } from "react-i18next";

import type { ContentLang } from "@/api/client";

// Hinweis-Banner, wenn die Sprache der Kursinhalte (metadata.content_lang)
// nicht zur UI-Sprache passt — bietet den Einstieg in den KI-Übersetzungs-
// Review-Flow an (bewusst KEIN stilles Auto-Übersetzen beim Sprachwechsel).
export default function ContentLangBanner({
  contentLang,
  onTranslate,
}: {
  contentLang: ContentLang;
  onTranslate: () => void;
}) {
  const { t, i18n } = useTranslation();
  const uiLang: ContentLang = i18n.language?.startsWith("en") ? "en" : "de";
  if (uiLang === contentLang) return null;
  return (
    <div className="mb-6 p-4 rounded-xl border border-verdict-amber bg-verdict-amber-bg flex flex-wrap items-center gap-3">
      <p className="flex-1 min-w-[16rem] text-sm font-semibold text-ca-surface-ink">
        {t(contentLang === "de" ? "translate.bannerContentDe" : "translate.bannerContentEn")}
      </p>
      <button
        type="button"
        onClick={onTranslate}
        className="px-4 py-2 rounded-md bg-ca-accent text-ca-brand text-xs font-black uppercase tracking-widest hover:bg-brand-gold-dark transition"
      >
        🌐 {t("translate.bannerCta")}
      </button>
    </div>
  );
}
